import React, { useContext } from "react";


import { LanguageContext } from "../LanguageContext"; // Import the LanguageContext
import "./Privacypolicy.css";
import SEO from "../components/SEO";
const Privacypolicy = () => {
  const { language } = useContext(LanguageContext); // Get the current language

  // ✅ **SEO Metadata for Privacy Policy Page**
  const metaTitle = "Privacy Policy - Snapseed QR Codes | Data Protection & User Rights";
  const metaDescription = "Learn how Snapseedqrcodes.download collects, stores, and protects your personal data while ensuring user privacy and security.";
  const metaUrl = "https://www.snapseedqrcodes.download/privacy-policy";
  const metaImage = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp";

  // ✅ **Schema Markup for Google SEO**
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "PrivacyPolicy",
    "headline": metaTitle,
    "description": metaDescription,
    "url": metaUrl,
    "image": metaImage,
    "publisher": {
      "@type": "Organization",
      "name": "Snapseed QR Codes",
      "logo": metaImage
    }
  };

  return (
    <div>
        {/* Use the SEO Component */}
      <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={schemaMarkup}
      
      />
      <section className="snapseed">
        <h1>{language === "english" ? "Privacy Policy" : "गोपनीयता नीति"}</h1>

        <h3>{language === "english" ? "Introduction" : "परिचय"}</h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "Welcome to Snapseedqrcodes.download (hereafter referred to as 'the website'). We maintain an unwavering commitment to protecting the privacy of all individuals on our digital platform. This comprehensive privacy policy describes the categories of personal information that Snapseedqrcodes.download collects and gathers, as well as the procedures that govern its use."
            : "स्वागत है Snapseedqrcodes.download पर (इसे आगे 'वेबसाइट' के रूप में संदर्भित किया जाएगा)। हम डिजिटल प्लेटफॉर्म पर आने वाले सभी व्यक्तियों की गोपनीयता की सुरक्षा के प्रति अडिग प्रतिबद्धता बनाए रखते हैं। इस व्यापक गोपनीयता नीति में उन व्यक्तिगत जानकारियों की श्रेणियों का वर्णन किया गया है जो Snapseedqrcodes.download प्राप्त करता है और एकत्र करता है, साथ ही उसके उपयोग को नियंत्रित करने वाली प्रक्रियाएं भी।"}
        </p>

        <h3>{language === "english" ? "Acceptance of Terms" : "शर्तों की स्वीकृति"}</h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "By using our website, you acknowledge and accept the terms outlined in this privacy policy. If you disagree with this privacy policy or any of its subsequent modifications, we request that you immediately cease using and accessing the website."
            : "हमारी वेबसाइट का उपयोग करके, आप इस गोपनीयता नीति में उल्लिखित शर्तों को मान्यता देते हैं और स्वीकार करते हैं। यदि आप इस गोपनीयता नीति या इसके किसी भी बाद के संशोधनों से असहमत हैं, तो हम आपसे तुरंत वेबसाइट के उपयोग और पहुँच को रोकने का अनुरोध करते हैं।"}
        </p>

        <h3>
          {language === "english"
            ? "Information Collection and Management"
            : "जानकारी संग्रहण और प्रबंधन"}
        </h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "We are the sole owners of this website and own all information collected here. Our data collection is limited to information voluntarily provided through email correspondence or direct communication channels. We clarify that your information will neither be sold nor leased to any third parties."
            : "हम इस वेबसाइट के एकमात्र मालिक हैं और यहां एकत्र की गई सभी जानकारियों के स्वामी हैं। हमारा डेटा संग्रह केवल आपके द्वारा ईमेल संवाद या सीधे संचार चैनलों के माध्यम से स्वेच्छा से प्रदान की गई जानकारी तक सीमित है। हम यहाँ स्पष्ट करते हैं कि आपकी जानकारी को न तो बेचा जाएगा और न ही किसी तृतीय पक्ष को पट्टे पर दिया जाएगा।"}
        </p>

        <h3>
          {language === "english"
            ? "Purpose of Information Usage"
            : "जानकारी के उपयोग का उद्देश्य"}
        </h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "The information you provide will be used solely to address your specific inquiries and maintain related communications. Sharing information with external parties will be limited to circumstances where such disclosure is necessary to fulfill your explicit requests."
            : "आपके द्वारा प्रदान की गई जानकारी का उपयोग केवल आपकी विशिष्ट पूछताछों को संबोधित करने और संबंधित संचार बनाए रखने के लिए किया जाएगा। बाहरी पक्षों के साथ जानकारी साझा करना केवल उन परिस्थितियों में सीमित रहेगा जहां ऐसा प्रकटीकरण आपके स्पष्ट अनुरोधों को पूरा करने के लिए आवश्यक हो।"}
        </p>

        <h3>
          {language === "english"
            ? "Types of Information Collected"
            : "एकत्रित जानकारी के प्रकार"}
        </h3>
        <ul className="benefits-list">
          <li>
            {language === "english"
              ? "Personal Information: We may collect personally identifiable information during newsletter subscriptions, form submissions, and website interactions. This information may include your name, email address, and additional voluntary submissions."
              : "व्यक्तिगत जानकारी: हम समाचार पत्रिका सदस्यताओं, फॉर्म सबमिशन, और वेबसाइट इंटरैक्शन के दौरान व्यक्तिगत रूप से पहचान योग्य जानकारी एकत्र कर सकते हैं। ऐसी जानकारी में आपका नाम, ईमेल पता, और अतिरिक्त स्वैच्छिक प्रस्तुतियाँ शामिल हो सकती हैं।"}
          </li>
          <li>
            {language === "english"
              ? "Non-Personal Information: Collection of technical data such as IP addresses, browser specifications, website navigation patterns, etc."
              : "गैर-व्यक्तिगत जानकारी: तकनीकी डेटा जैसे कि IP पते, ब्राउज़र विनिर्देशों, वेबसाइट नेविगेशन पैटर्न आदि का संग्रह।"}
          </li>
        </ul>

        <h3>
          {language === "english"
            ? "External Content Integration"
            : "बाहरी सामग्री एकीकरण"}
        </h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "Our website may include embedded content from external sources. Such content operates just like a direct website visit, enabling third-party data collection, cookie deployment, tracking implementations, and interaction monitoring."
            : "हमारी वेबसाइट बाहरी स्रोतों से एम्बेडेड सामग्री को शामिल कर सकती है। ऐसी सामग्री सीधे वेबसाइट विज़िट की तरह काम करती है, जिससे तीसरे पक्ष के डेटा संग्रह, कुकीज़ की तैनाती, ट्रैकिंग कार्यान्वयन, और इंटरैक्शन मॉनिटरिंग संभव हो सकती है।"}
        </p>

        <h3>
          {language === "english"
            ? "Information Control Rights"
            : "जानकारी नियंत्रण अधिकार"}
        </h3>
        <ul>
          <li>
            {language === "english"
              ? "Review your stored information"
              : "अपनी संग्रहीत जानकारी की समीक्षा कर सकते हैं"}
          </li>
          <li>
            {language === "english"
              ? "Modify or correct existing data"
              : "मौजूदा डेटा को संशोधित या सुधार सकते हैं"}
          </li>
          <li>
            {language === "english"
              ? "Request complete data deletion"
              : "पूर्ण डेटा मिटाने का अनुरोध कर सकते हैं"}
          </li>
          <li>
            {language === "english"
              ? "Express concerns about data use"
              : "डेटा उपयोग को लेकर चिंताएं व्यक्त कर सकते हैं"}
          </li>
        </ul>

        <h3>
          {language === "english" ? "Security Measures" : "सुरक्षा उपाय"}
        </h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "We implement robust security protocols to protect your information. Sensitive data transmission uses encryption technology, verified by HTTPS protocols and Secure Socket Layer (SSL) certification. However, we acknowledge that no electronic transmission method guarantees complete security."
            : "हम आपकी जानकारी की सुरक्षा के लिए दृढ़ सुरक्षा प्रोटोकॉल लागू करते हैं। संवेदनशील डेटा संचरण में एन्क्रिप्शन तकनीक का उपयोग होता है, जिसे HTTPS प्रोटोकॉल और सुरक्षित सॉकेट लेयर (SSL) प्रमाणन द्वारा सत्यापित किया जाता है। हालांकि, हम स्वीकार करते हैं कि कोई भी इलेक्ट्रॉनिक संचरण विधि पूर्ण सुरक्षा की गारंटी नहीं देती है।"}
        </p>

        <h3>
          {language === "english" ? "Policy Modifications" : "नीति संशोधन"}
        </h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "We reserve the right to modify this privacy policy from time to time. Significant changes will be communicated to registered users via email notification or through major website announcements."
            : "हम इस गोपनीयता नीति को समय-समय पर संशोधित करने का अधिकार सुरक्षित रखते हैं। महत्वपूर्ण परिवर्तनों को पंजीकृत उपयोगकर्ताओं को ईमेल अधिसूचना के माध्यम से या प्रमुख वेबसाइट घोषणाओं के जरिए संचारित किया जाएगा।"}
        </p>

        <h3>
          {language === "english" ? "Consent Declaration" : "सहमति घोषणा"}
        </h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "Use of the website constitutes explicit consent to this privacy policy and its specified terms."
            : "वेबसाइट का उपयोग इस गोपनीयता नीति और इसकी निर्दिष्ट शर्तों के प्रति स्पष्ट सहमति को दर्शाता है।"}
        </p>
      </section>
    </div>
  );
};

export default Privacypolicy;
